import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetBonusContextGames = () => {
    const send = useGenericSend();

    return useCallback(async (request: { bonusInstanceCode: string; remoteBonusId?: string; systemId?: number }):
        Promise<Types.IUseGetBonusContextGamesResponseData> => {
            const { data } = await send<Types.IUseGetBonusContextGamesRequestData, Types.IUseGetBonusContextGamesResponseData>({
                ID: 35502,
                description: 'Get Bonus Context Games',
                responses: [35503, 35504],
                ...request
            });

            return data;
    }, [send]);
};
